<template>
    <div>
        <div v-if="$store.state.user">
            <v-btn class="ma-1" color="primary" v-for="door in doors" :key="door.id" :loading="door.loading" @click="open(door)"><v-icon>mdi-door-open</v-icon>{{$translate('Open')}} {{door.name}}</v-btn>
        </div>
        <div v-else></div>

        <div v-if="$root.edit && !doors.length">
            {{$translate('It seems that there are no doors to open. But here will appear buttons to open doors.')}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-mydoors',

    zoezi: {
        title: 'My doors',
        icon: 'mdi-door-open'
    },

    data: () => ({
        doors: []
    }),

    methods: {
        getDoors() {
            this.$api.get('/api/door/get', {site_id: this.$store.state.selectedSiteId}).then((data) => {
                this.doors = data.filter(door => door.active);
                this.doors.forEach(door => door.loading = false);

             //   this.doors = [{id: 1, name: 'Ytterdörren', active: true}]
            });
        },
        open(door)  {
            door.loading = true;
            this.$api.post('/api/door/open', null, {id: door.id}).then(response => response.json().then(data => {
                door.loading = false;
                if (!response.ok) {
                    this.$store.commit('showErrorDialog', {
                        title: this.$translate('Could not open the door'),
                        text: data.message
                    })
                }
            }))
        }
    },

    mounted() {
        this.getDoors();

        /*

        FIXME: Lägg in motsvarande till:
        live.subscribe({
        type: 'resourcebookingservice',
        callback: function(__, event) {
            if (['add', 'change'].indexOf(event.action) === -1) { return; }
            var service = _.findWhere(event.data, { continuousBooking: true });
            if (service) {
                updateDoors();
            }
        }
    });*/
    }
}
</script>